// js
import React from 'react';
import PropTypes from 'prop-types';
// css
import '../../styles/components/common/ColorLegend.scss';


const ColorLegend = ({ items }) => {
  const legendItems = items.map((item, index) => {
    const colSize = Math.floor(12.0 / items.length);
    const colors = item.color ? [item.color] : item.colors;

    return (
      <div
        key={index}
        className={`color-legend__item col-md-${colSize}`}>
        <div className='color-legend__colors'>
          {colors.map((color, index) => (
            <div
              key={index}
              className='color-legend__color'
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
        <div className='color-legend__text'>
          <div className='color-legend__label'>
            {item.label}
          </div>
          <div className='color-legen__subtext'>
            {item.subtext}
          </div>
        </div>
      </div>
    );
  });

  return (
    <div className='color-legend'>
      <div className='row'>
        {legendItems}
      </div>
    </div>
  );
};

ColorLegend.propTypes = {
  items: PropTypes.array.isRequired
};

export default ColorLegend;



// WEBPACK FOOTER //
// ./src/components/common/ColorLegend.js